import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import HandoutList from "../components/HandoutList";

function CoreSkills() {
  const navigate = useNavigate();

  const handouts = [
    {
      title: "Teaching Clicker Training",
      link: "https://drive.google.com/file/d/1xjvRiC29pQruFKnuPGXbyld5Ob4ZXkg-/view?usp=sharing",
    },
    {
      title: "Teaching Focus / Look At Me",
      link: "https://drive.google.com/file/d/11Ly9NxIl2gaLaFxHUOE86L8HVECjDb39/view?usp=sharing",
    },
    {
      title: "Teaching Hand Target",
      link: "https://drive.google.com/file/d/1dCsIn3Wm7J_9MmBveDosYaugPvGGAHh4/view?usp=sharing",
    },
    {
      title: "Teaching Drop It",
      link: "https://drive.google.com/file/d/1jZnR_AN9fA2VXsM-ZozTe6cGj3RN93hC/view?usp=sharing",
    },
    {
      title: "Teaching Leave It",
      link: "https://drive.google.com/file/d/1jF94TdxOgp8Ua7KxHwgGhTRDKf0DWawG/view?usp=sharing",
    },
  ];

  return (
    <>
      <Header />
      <div className="min-h-screen p-8 bg-gray-50">
        <button
          onClick={() => navigate("/home")}
          className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-sm"
        >
          ← Back to Dashboard
        </button>

        <h1 className="text-4xl font-bold text-gray-800 mb-2">Core Skills</h1>
        <p className="text-lg text-gray-600 mb-8 max-w-3xl">
          These handouts cover essential foundation behaviours every dog should learn.
        </p>

        <HandoutList title="Handouts" items={handouts} />
      </div>
    </>
  );
}

export default CoreSkills;
